import styles from "./tripsSection.css";

import Section from "../section";
import TripThumbnail from "./tripThumbnail";
import safaris from "../../../data/safaris.json";

function SafarisSection() {
  return (
    <Section title="SAFARI">
      <div className="trips-section">
        {safaris.map((safari, index) => (
          <TripThumbnail trip={safari} type="safari" key={index} />
        ))}
      </div>
    </Section>
  );
}

export default SafarisSection;
